import schedulesViewStateStore from "../../store/store";
import { mutatorAction } from "satcheljs";

export default mutatorAction("CLEAR_FILTERED_TAGS", function clearFilteredTags() {
    schedulesViewStateStore().filteredTags.clear();
});
